import React, { useState } from 'react';
import { motion } from 'framer-motion';

const WhatSetsUsApart = () => {
    const [activeTab, setActiveTab] = useState('approach');

    const contentData = [
        {
            id: 'approach',
            tabName: 'Our Approach',
            title: 'Our Approach',
            text: "Over the years, working with new technologies and different clients has taught us to keep things simple and practical. At Mobikode, we don’t just deliver solutions, we help you understand and use them comfortably, making sure they fit smoothly into your workflow and are accessible to everyone involved.",
            image: '/assets/what/item13.png',
        },
        {
            id: 'innovation',
            tabName: 'Our Innovation',
            title: 'Our Innovation',
            text: "With years of hands-on experience in modern technologies and working with diverse clients, we at Mobikode take a practical, human-first approach. We don’t just implement IT solutions, we make sure your team actually understands them, feels comfortable using them, and can access them easily. Our focus is simple: smooth adoption, real usability, and systems that work for everyone involved.",
            image: '/assets/what/item12.png',
        }
    ];

    const sortedData = [...contentData].sort((a, b) => {
        if (a.id === activeTab) return -1;
        if (b.id === activeTab) return 1;
        return 0;
    });

    return (
        <section className="w-full bg-white py-16 md:py-24 font-sans">
            <div className="max-w-[1440px] mx-auto px-6 lg:px-8">

                <div className="text-center mb-10">
                    <motion.h2
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        className="text-[#01386A] text-[20px] md:text-[30px] font-[600] font-sora mb-6"
                    >
                        What Sets Us Apart
                    </motion.h2>
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                        viewport={{ once: true }}
                        className="text-[#01386A] font-[500] text-[14px] md:text-[16px] font-graphik max-w-3xl mx-auto leading-relaxed"
                    >
                        We help businesses find the right solutions that truly fit their goals and support their growth in a practical, meaningful way.
                    </motion.p>
                </div>

                <div className="flex justify-center mb-12">
                    <div className="inline-flex rounded-full border border-gray-300 p-1 bg-white">
                        {contentData.map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`px-6 py-2.5 rounded-full text-[14px] lg:text-[16px] font-[500] font-graphik transition-all duration-300 ${activeTab === tab.id
                                    ? 'bg-[#01386A] text-white shadow-md'
                                    : 'bg-transparent text-[#01386A] hover:bg-gray-100'
                                    }`}
                            >
                                {tab.tabName}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="flex flex-col gap-8">
                    {sortedData.map((item) => (
                        <motion.div
                            layout
                            key={item.id}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{
                                layout: { type: "spring", stiffness: 300, damping: 30 },
                                opacity: { duration: 0.4 }
                            }}
                            className={`w-full flex flex-col md:flex-row items-stretch gap-8 md:gap-12 bg-white border border-[#01386A] !border-b-0 p-8 md:p-[30px] lg:p-[40px] shadow-sm relative overflow-hidden group`}
                        >
                            <div className="absolute bottom-[-1px] left-0 h-[5px] w-full bg-[#01386A]"></div>
                            <div className="absolute bottom-[-1px] left-0 h-[5px] w-0 bg-[#ED6800] group-hover:w-full transition-all duration-500 ease-out z-10"></div>

                            {/* Left Text Container */}
                            <div className="w-full md:w-1/2 flex flex-col justify-between z-20">
                                <h3 className="text-[#01386A] text-[20px] md:text-[30px] font-[600] font-sora mb-6">
                                    {item.title}
                                </h3>
                                <p className="text-[#01386A] font-[500] text-[14px] md:text-[16px] font-graphik leading-[1.8] text-justify">
                                    {item.text}
                                </p>
                            </div>

                            {/* Right Image Container */}
                            <div className="w-full md:w-1/2 h-[250px] md:h-auto shrink-0 flex items-stretch z-20">
                                <img
                                    src={item.image}
                                    alt={item.title}
                                    className="w-full h-full object-cover shadow-sm"
                                />
                            </div>
                        </motion.div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default WhatSetsUsApart;